<template>
  <div class="flex min-h-screen w-full flex-col justify-between">
    <JumpTab />
    <header class="z-40">
      <AppNavigation />
      <SubHeader />
    </header>

    <DesktopNavigation class="max-xl:hidden" />
    <main
      id="jump-content"
      class="
        flex flex-1 flex-col pb-24 pt-18
        print:pb-4 print:pt-6
      "
      @focusin="navigation.setOpenState(false)"
    >
      <NuxtPage @entry-loaded="setEntry" />
    </main>

    <AppFooter />
  </div>
</template>

<script lang="ts" setup>
import type { PageQuery } from '#gql'

const navigation = useNavigationStore()
const route = useRoute()
const formatError = (error: unknown) => {
  return createError({
    fatal: true,
    // @ts-ignore
    statusCode: error?.status ?? 500,
    message: error instanceof Error ? error.message : 'An error occurred',
  })
}

const globals = await useInjectableGlobals().catch((error) => {
  throw formatError(error)
})

const theme = computed(() => globals.value.theme.theme.value || 'aplus')
const favicon = computed(() => {
  switch (theme.value) {
    case 'integrity':
      return '/favicon-integrity.ico'
    case 'nsan':
      return '/favicon-nsan.ico'
    case 'aplus':
      return '/favicon.ico'
    default:
      return '/favicon.ico'
  }
})

provide(ThemeKey, theme)

useHead({
  htmlAttrs: { 'data-theme': theme },
  link: [
    {
      rel: 'icon', type: 'image/x-icon', href: favicon,
    },
  ],
})

const entry = ref<PageQuery['entry'] | undefined>(undefined)
const setEntry = (newEntry: PageQuery['entry']) => (entry.value = newEntry)

provide(GlobalsKey, globals)
provide(EntryInjectionKey, entry)

if (import.meta.client) {
  document.body.classList.add(useIsTouchDevice() ? 'is-touch' : 'no-touch')
}

watch(() => theme, (newTheme) => {
  document.documentElement.setAttribute('data-theme', newTheme.value)
})
</script>
